import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';
import type { AxiosResponse } from 'axios';
import type { ChangePasswordPayload } from '../../types';

export const accountApi = {
  /**
   * POST /api/v1/Account/ChangePassword
   * Changes the authenticated user's password.
   */
  changePassword: (
    payload: ChangePasswordPayload,
  ): Promise<AxiosResponse<void>> =>
    apiClient.post<void>(API_ENDPOINTS.ACCOUNT.CHANGE_PASSWORD, payload),

  /**
   * POST /api/v1/Account/DeleteMyAccount
   * Deletes the authenticated user's account.
   */
  deleteMyAccount: (): Promise<AxiosResponse<void>> =>
    apiClient.post<void>(API_ENDPOINTS.ACCOUNT.DELETE_MY_ACCOUNT),
};

export default accountApi;
